// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"xi-z","flipped":"yi-z","mainContentContainer":"zi-z","cta":"Ai-z","mainContentCtaDefault":"Bi-z","disabled":"Ci-z","mainContentCtaWhite":"Di-z"};